import TyAutoLoad from './TyAutoLoad.vue'
export default TyAutoLoad



// WEBPACK FOOTER //
// ./src/components/ty-auto-load/index.js